import { render, staticRenderFns } from "./ReleaseApply.vue?vue&type=template&id=8f5dec8c&scoped=true&"
import script from "./ReleaseApply.vue?vue&type=script&lang=js&"
export * from "./ReleaseApply.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseApply.vue?vue&type=style&index=0&id=8f5dec8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5dec8c",
  null
  
)

export default component.exports